module.exports = __webpack_public_path__ + "static/media/Estados Financieros Palacio 2020.972dfae4.pdf";